// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var canvas = document.createElement("canvas");

function getTextWidth(text, font) {
  var context = canvas.getContext("2d");
  context.font = font;
  return context.measureText(text).width;
}

function calcColumnWidth(query, min, max) {
  var cells = document.querySelectorAll(query);
  if (cells.length <= 0) {
    return min;
  }
  var font = window.getComputedStyle(cells.item(0)).getPropertyValue("font");
  var maxWidth = 0;
  for(var i = 0 ,i_finish = cells.length; i < i_finish; ++i){
    maxWidth = Math.max(maxWidth, getTextWidth(cells.item(i).innerText, font));
  }
  return Math.min(max, Math.max(min, maxWidth));
}

exports.calcColumnWidth = calcColumnWidth;
/* canvas Not a pure module */
